// extracted by mini-css-extract-plugin
export default {"tooltip":"Sm-z","sharingV2":"Tm-z","sharingIconsV2":"Um-z","links":"Vm-z","link":"Wm-z","facebookV2":"Xm-z","twitterV2":"Ym-z","pinterestV2":"Zm-z"};